import { Typography as InnerTypography } from './typography';
import { Title } from './title';
import { SubTitle } from './sub-title';
import { Paragraph } from './paragraph';
const Typography = InnerTypography;
Typography.Title = Title;
Typography.SubTitle = SubTitle;
Typography.Paragraph = Paragraph;
export default Typography;
